/* eslint-disable */
// Converts the response of GET user/get-onboarding-questions into the shape
// the onboarding screens already read (the old onboarding/config shape).
// That way the screens don't need to change.

const bySortOrder = (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0);

const findQuestion = (questions, code) =>
  (questions || []).find(q => q.code === code);

// Option `code` becomes the `id` the screens use (e.g. 'weekly', 'benzine').
// `optionId` and `questionId` are kept for saving the answers later (Stage B).
const frequencyOption = (opt, questionId) => {
  const m = opt.metadata || {};
  return {
    id: opt.code,
    optionId: opt.id,
    questionId,
    fillsPerMonth: opt.value, // fill-ups per month, used for the savings maths
    tag: m.tag,
    label: opt.label,
    highlighted: !!m.highlighted,
    default: !!m.default,
    yearlySavings: m.yearlySavings,
    forecast: m.forecast,
  };
};

const fuelOption = (opt, questionId) => {
  const m = opt.metadata || {};
  return {
    id: opt.code,
    optionId: opt.id,
    questionId,
    label: opt.label,
    sublabel: m.sublabel,
    chip: m.chip,
    default: !!m.default,
    saving: m.saving,
  };
};

export const adaptQuestionsResponse = (data = {}) => {
  const frequencyQ = findQuestion(data.questions, 'fuel_frequency');
  const fuelQ = findQuestion(data.questions, 'fuel_type');
  const result = {};

  if (frequencyQ?.options?.length) {
    result.fuelFrequency = {
      options: [...frequencyQ.options]
        .sort(bySortOrder)
        .map(o => frequencyOption(o, frequencyQ.id)),
    };
  }
  if (fuelQ?.options?.length) {
    result.fuelType = {
      options: [...fuelQ.options]
        .sort(bySortOrder)
        .map(o => fuelOption(o, fuelQ.id)),
    };
  }

  // Question ids, needed when the answers are saved.
  result.questionIds = {
    fuelFrequency: frequencyQ?.id ?? null,
    fuelType: fuelQ?.id ?? null,
  };

  // Fuel prices keyed by the fuel id the screens use (the API names differ:
  // petrol -> benzine, ev -> electric). Used for the savings maths.
  const API_FUEL_TO_APP = {petrol: 'benzine', diesel: 'diesel', ev: 'electric', lpg: 'lpg'};
  const fuelPrices = {};
  (data.fuelPrices || []).forEach(p => {
    const appId = API_FUEL_TO_APP[p.fuelType];
    if (appId) {
      fuelPrices[appId] = p;
    }
  });
  if (Object.keys(fuelPrices).length) {
    result.fuelPrices = fuelPrices;
  }

  // Welcome screen numbers: petrol is the headline price.
  const petrol = (data.fuelPrices || []).find(p => p.fuelType === 'petrol');
  const welcome = {};
  if (petrol) {
    welcome.unit = petrol.unit;
    welcome.otherStationsPrice = petrol.stationPrice;
    welcome.pompiBestPrice = petrol.pompiPrice;
    welcome.savingsPerFillUp = petrol.savingsPerFillUp;
  }
  if (data.users) {
    welcome.stats = {
      rating: data.users.rating,
      drivers: data.users.signedUp,
    };
  }
  if (Object.keys(welcome).length) {
    result.welcome = welcome;
  }

  return result;
};